import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import SubscriptionsIntervalLoader from "../../Loaders/SubscriptionsIntervalLoader";
import SubscriptionsLoader from "../../Loaders/SubscriptionsLoader";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const MainPricing = () => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const [loadingPackages, setLoadingPackages] = useState(false)
    const [error, setError] = useState({ message: "", display: false });
    const [packages, setPackages] = useState([])
    const [selectedInterval, setSelectedInterval] = useState(null)

    const fetchPackages = async () => {
        setError({ message: "", display: false });
        setLoadingPackages(true);
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_packages`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });

            if (!response.ok) throw new Error("Failed to fetch user session");

            const data = await response.json();
            setPackages(data.data);

            setTimeout(() => setLoadingPackages(false), 2000);
        } catch (error) {
            console.error("Error fetching session:", error);
            setLoadingPackages(false)
            setError({ message: "An error occurred while getting packages... retry in a few minutes", display: true })
        }
    };

    const filteredPackages = packages.filter((item) => {
        if (item.type === "one_time") return true;
        return item.type === selectedInterval;
    });


    useEffect(() => {
        fetchPackages()
    }, [])

    useEffect(() => {
        if (packages.length > 0) {
            setSelectedInterval("monthly")
        }
    }, [loadingPackages])


    return (
        <div className="main_pricing">
            <Navbar showToggle={false}/>
            <div className="main_pricing_cont">
                <div className="main_pricing_cont_header">
                    <p className="main_pricing_cont_kicker">E8</p>
                    <p className="main_pricing_cont_title">{t.website.pricing.title}</p>
                    <p className="main_pricing_cont_subtitle">{t.website.pricing.subtitle}</p>

                    <div className="main_pricing_inner_cont">
                        {loadingPackages ? (
                            <SubscriptionsIntervalLoader />
                        ) : (
                            <div className="monthly_yearly_cont">
                                <button className={`monthly_yearly_choise fade-in ${selectedInterval == "monthly" && "monthly_yearly_choise_selected"}`} onClick={() => { setSelectedInterval("monthly") }}>{t.website.pricing.monthly}</button>
                                <button className={`monthly_yearly_choise fade-in ${selectedInterval == "yearly" && "monthly_yearly_choise_selected"}`} onClick={() => { setSelectedInterval("yearly") }}>{t.website.pricing.yearly}</button>
                                <button className={`monthly_yearly_choise fade-in ${selectedInterval == "custom" && "monthly_yearly_choise_selected"}`} onClick={() => { setSelectedInterval("custom") }}>{t.website.pricing.custom}</button>
                            </div>
                        )
                        }
                        <div className="subscriptions_cont">
                            {loadingPackages ? (
                                <SubscriptionsLoader />
                            ) : (
                                filteredPackages.length > 0 ? (
                                    filteredPackages.map((item) => (
                                        <div
                                            key={item.id}
                                            className={`subscriptions_item fade-in`}
                                        >
                                            <p className="subscriptions_item_tile fade-in">
                                                {item.name}
                                                {(item.type !== "one_time" && item.type !== "custom") && (
                                                    <span className="subscriptions_item_price fade-in">
                                                        ${Number(item.price).toFixed(2)}
                                                    </span>
                                                )}
                                            </p>

                                            <p className="subscriptions_item_desc fade-in">{item.description}</p>


                                            {item.name == "Pay as you go" ? (
                                                <p className="subscriptions_item_discount_mex_no_color fade-in">No discount</p>
                                            ) : item.name == "Enterprise" ? (
                                                <p className="subscriptions_item_discount_mex fade-in">Tailored discount</p>
                                            ) : (
                                                <p className="subscriptions_item_discount_mex fade-in">{item.discount_percentage}% discount on all usage</p>
                                            )}

                                            {((item.name === "Starter" || item.name === "Growth" || item.name === "Pro") && item.type == "yearly") && (
                                                <div className="subscriptions_item_discount fade-in">
                                                    <strong>-10% yearly</strong>
                                                </div>
                                            )}
                                            <div
                                                className={`subscriptions_item_btn fade-in`}
                                                onClick={() => navigate("/register")}
                                            >
                                                Select
                                            </div>

                                        </div>
                                    ))
                                ) : (
                                    <div className="organizations_cont_no_items_mex fade-in">
                                        <p>No packages available.</p>
                                    </div>
                                )
                            )}
                        </div>
                    </div>

                    <div className="payment_info_cont">
                        <div className="payment_info_section">
                            <p className="payment_info_cont_title">{t.website.how_payments_work.one_title}</p>

                            <p className="payment_info_cont_parag">{t.website.how_payments_work.one_subtitle}</p>
                        </div>

                        <div className="payment_info_section">
                            <p className="payment_info_cont_title">{t.website.how_payments_work.two_title}</p>
                            <p className="payment_info_cont_parag">{t.website.how_payments_work.two_subtitle}</p>
                        </div>

                        <div className="payment_info_section">
                            <p className="payment_info_cont_title">{t.website.how_payments_work.three_title}</p>
                            <p className="payment_info_cont_parag">{t.website.how_payments_work.three_subtitle}</p>
                        </div>

                        <div className="payment_info_section">
                            <p className="payment_info_cont_title">{t.website.how_payments_work.four_title}</p>
                            <p className="payment_info_cont_parag">{t.website.how_payments_work.four_subtitle}</p>
                        </div>

                        <div className="payment_info_section">
                            <p className="payment_info_cont_title">
                                {t.website.how_payments_work.five_title}
                            </p>

                            <p className="payment_info_cont_parag">
                                {t.website.how_payments_work.five_subtitle}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default MainPricing